import { FormListOperation } from 'antd';
import React from 'react';
import { isEqual } from 'lodash';
import styles from './CustomRequestRow.module.scss';
import { CustomRequestRowContent } from './CustomRequestRowContent';

type CustomRequestRowImplProps = {
    index: number;
    remove: FormListOperation['remove'];
};

const CustomRequestRowImpl = ({ index, remove }: CustomRequestRowImplProps): JSX.Element => {
    return (
        <div className={styles['custom-req-row']}>
            <CustomRequestRowContent index={index} onRemove={() => remove(index)} />
        </div>
    );
};

export const CustomRequestRow = React.memo(CustomRequestRowImpl, (prev, next) => isEqual(prev, next));
